import React from 'react';

type Props = React.SVGProps<SVGSVGElement>;

const ShareHugeIcon = (props: Props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="48" viewBox="0 0 48 48" {...props}>
      <path
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="4"
        d="M28 6h14v14m0 9.474V39a3 3 0 0 1-3 3H9a3 3 0 0 1-3-3V9a3 3 0 0 1 3-3h9m7.8 16.2L41.1 6.9"
      />
    </svg>
  );
};

export default ShareHugeIcon;
